import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from '../../core/store.service';
import { HttpService, EndWithSlash } from 'projects/lib-components/src/public_api';
import { BaseStage } from '../base-stage';
import { GenericData, Stage, StageYear, StagesModel, Address, StageDataOPT, CatalogueOPT, AddressOPT, StageDataFLT, CategorieOPT, ProdDataFLT, SessionItem, eItem, Product } from '../../shared';

@Component({
  selector: 'webstore-stages-list',
  templateUrl: './stages-list.component.html',
  styleUrls: ['./stages-list.component.css']
})

export class StagesListComponent extends BaseStage implements OnInit {
  public parentProductName: string = '';
  public nbStage: number;
  public splashStage: boolean = true;
  public stagesOPT: GenericData<StageDataOPT>[] = [];
  public stagesFilteredOPT: GenericData<StageDataOPT>[] = [];
  public splashFilter: boolean = true;
  public catalogs: CatalogueOPT[];
  public addresses: AddressOPT[];
  public yearList: StageYear[];

  constructor(
    public store: StoreService,
    protected http: HttpService,
    protected router: Router
  ) {
    super(store);
  }

  ngOnInit(): void {
    this.store.showSplash(false);
    this.initCall1();
    this.initCall2();
  }
  private initCall1(): void {
    this.splashStage = true;
    const dest1: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/stageslist/getData/V2/STAGELIST1/0`;
    this.http.getHttp<StagesModel>(dest1).subscribe((data: StagesModel): void => {
      if (!data.HasError) {
        this.nbStage = data.StageModelOptimized.Stages.length;
        if (this.nbStage === 0) {
          this.store.warning(this.store.getTrad('nostage'));
          this.splashStage = false;
          return;
        }

        this.stagesOPT = this.store.convertList<StageDataOPT>(data.StageModelOptimized.Stages, 2);
        this.stagesFilteredOPT = this.stagesOPT;
        this.parentProductName = '';

        const parentProduct: SessionItem | null = super.getSession(eItem.PRODUCT);
        if (parentProduct) {
          if (this.stagesOPT && parentProduct.code && parentProduct.code !== '') {
            const pd: Product = JSON.parse(parentProduct.jsData);
            this.parentProductName = `${pd.DesigPRO} [${parentProduct.code}]`;
            this.stagesFilteredOPT = super.filterStagesProd2(this.stagesFilteredOPT, parentProduct.code);
            super.removeSession(eItem.PRODUCT);
          }
        }
      }
      this.splashStage = false;
    });
  }
  private initCall2(): void {
    this.splashFilter = true;
    const dest1: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/stageslist/getData/V2/STAGELIST2/0`;
    this.http.getHttp<StagesModel>(dest1).subscribe((data: StagesModel): void => {
      if (!data.HasError) {
        if (data.StageModelOptimized.Catalogs.length > 0) {
          this.yearList = data.StageModelOptimized.FilterYears;
          this.catalogs = data.StageModelOptimized.Catalogs;
          this.addresses = data.StageModelOptimized.Addresses;
        }
      }
      this.splashFilter = false;
    });
  }

  formatContent(cnt: string): string {
    return cnt.length > 250 ? `${cnt.substring(0, 250)} ... ` : cnt;
  }
  formatTooltip(cnt: string): string {
    return cnt.length > 250 ? cnt : '';
  }

  getCurrentStage(stage: Stage): void {
    super.setStage(stage);
    this.router.navigate([this.store.AppRoutes.STAGEDETAILS]);
  }

  getStagesByDate(year: number, month: number): void {
    this.stagesFilteredOPT = this.filterStagesOptDate(year, month);
  }

  getStagesByProduct(prod: ProdDataFLT): void {
    this.stagesFilteredOPT = this.filterStagesOptProd(prod.CodeProduct);
  }

  getStagesByCategorie(ctg: CategorieOPT): void {
    this.stagesFilteredOPT = this.filterStagesOptCateg(ctg.ListStages);
  }

  getStagesByAddress(item: Address): void {
    this.stagesFilteredOPT = this.filterStagesOptAddress(item);
  }

  getAllSession(): void {
    this.stagesFilteredOPT = this.stagesOPT;
  }

  private filterStagesOptDate(yearP: number, monthP: number): GenericData<StageDataOPT>[] {
    let result: GenericData<StageDataOPT>[] = [];
    let ms: StageDataOPT[] = [];
    for (let n: number = 0; n < this.stagesOPT.length; n++) {
      const t: StageDataOPT[] = this.stagesOPT[n].listFils.filter((e: Stage): boolean => e.year === yearP && e.month === monthP);
      if (t.length > 0)
        ms = ms.concat(t);
    }
    if (ms.length === 0) { this.store.warning(this.store.getTrad('nostage')); }
    result = this.store.convertList<StageDataOPT>(ms, 2);
    return result;
  }

  private filterStagesOptAddress(address: Address): GenericData<StageDataOPT>[] {
    let result: GenericData<StageDataOPT>[] = [];
    let ms: StageDataOPT[] = [];
    for (let n: number = 0; n < this.stagesOPT.length; n++) {
      for (let x: number = 0; x < this.stagesOPT[n].listFils.length; x++) {
        if (this.stagesOPT[n].listFils[x].AddressesList) { // && list[n].listFils[x].AddressesList.indexOf(address) > -1) {
          const rs: Address[] = this.stagesOPT[n].listFils[x].AddressesList.filter((a: Address): boolean => a.FormatADR === address.FormatADR);
          if (rs.length > 0) {
            ms = ms.concat(this.stagesOPT[n].listFils[x]);
          }
        }
      }
    }
    if (ms.length === 0) { this.store.warning(`${this.store.getTrad('nostage')} for the address ${address.FormatADR}`); }
    result = this.store.convertList<StageDataOPT>(ms, 2);
    return result;
  }

  private filterStagesOptProd(codeProd: string): GenericData<StageDataOPT>[] {
    let result: GenericData<StageDataOPT>[] = [];
    let ms: StageDataOPT[] = [];
    for (let n: number = 0; n < this.stagesOPT.length; n++) {
      const t: StageDataOPT[] = this.stagesOPT[n].listFils.filter((e: Stage): boolean => e.ProduPRO === codeProd);
      if (t.length > 0)
        ms = ms.concat(t);
    }
    if (ms.length === 0) { this.store.warning(`Il n'y a pas des sessions pour le produit sélectionnés}`); }
    result = this.store.convertList<StageDataOPT>(ms, 2);
    return result;
  }

  private filterStagesOptCateg(stages: StageDataFLT[]): GenericData<StageDataOPT>[] {
    const listId: string[] = stages.map(function (stg: StageDataFLT): string { return stg.IdStage; }); //.join(',');


    let result: GenericData<StageDataOPT>[] = [];
    let ms: StageDataOPT[] = [];
    for (let n: number = 0; n < this.stagesOPT.length; n++) {
      const t: StageDataOPT[] = this.stagesOPT[n].listFils.filter((e: Stage): boolean => listId.indexOf(e.Ident) > -1);
      if (t.length > 0)
        ms = ms.concat(t);
    }
    if (ms.length === 0) { this.store.warning(`Il n'y a pas des sessions pour le produit sélectionnés`); }
    result = this.store.convertList<StageDataOPT>(ms, 2);
    return result;
  }
}
